import { render } from "./Footer.vue?vue&type=template&id=4ea1c0d8"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script